import { useQueryParams } from 'hookrouter'
import { getBrowserUser } from 'lib/BrowserStorage'
import { useEffect} from 'react'
import {
  fetchCompanies,
  fetchProjects,
  fetchTemplateDocuments,
  fetchUser,
  getSpecificRoles,
  viewTemplateDirectories
} from 'state/async_actions'
import { useAppContext } from 'state/context'

export const useDataLoader = (
  companyId: number | undefined,
  projectId: number | undefined,
  templateDocumentId?: number | undefined,
  templateSubDocumentId?: number | undefined,
  isTemplate?: boolean,
  userType?: string | undefined
) => {
  const params = useQueryParams();

  const [
    {
      user: { id },
    },
    dispatch,
  ] = useAppContext()

  useEffect(() => {
    if (id) {
      fetchUser(dispatch, id)
    } else {
      const userId = getBrowserUser().id
      if (userId) {
        fetchUser(dispatch, userId)
      }
    }
  }, [dispatch, id])

  useEffect(() => {
    fetchCompanies(dispatch)
  }, [dispatch])

  useEffect(() => {
    if (companyId) {
      fetchProjects(dispatch, companyId)
    }
  }, [dispatch, companyId])

  useEffect(() => {
    if(projectId)
    viewTemplateDirectories(dispatch, projectId)
  }, [dispatch, projectId])

  useEffect(() => {
    if (projectId && userType) {
      getSpecificRoles(dispatch, projectId, templateDocumentId || params?.[0]?.templateDocumentId, userType)
    }
  }, [dispatch, projectId, userType])

  useEffect(() => {
    if (projectId && !isTemplate) {
      fetchTemplateDocuments(dispatch, projectId, templateSubDocumentId ? templateSubDocumentId : templateDocumentId)
    }
  }, [dispatch, projectId, templateDocumentId, templateSubDocumentId ])

}

export const fetchTemplateDirectories = (
  dispatch:any,
  projectId: any,
  templateDocumentId?: number | undefined,
  templateSubDocumentId?: number | undefined)=>{
  return fetchTemplateDocuments(dispatch, projectId, templateSubDocumentId ? templateSubDocumentId : templateDocumentId)
  
}